<template>
  <Modal
    class="confirmationModal"
    :class="modal"
    :title="modalTitle"
    :isOpen="isOpen"
    @close="emits('close')"
    :buttons="[]"
  >
    <template #extra>
      <component
        :is="modalContents[modal].component"
        :data="data"
        @close="emits('close')"
        @confirm="emits('confirm')"
      />
    </template>
  </Modal>
</template>

<script setup>
import { computed } from "vue";
import ActivateParticipant from "./partials/ActivateParticipant.vue";
import DesactivateParticipant from "./partials/DesactivateParticipant.vue";
import DeleteParticipant from "./partials/DeleteParticipant.vue";
import MoveParticipant from "./partials/MoveParticipant.vue";
import ArchiveCampaign from "./partials/ArchiveCampaign.vue";
import RestoreCampaign from "./partials/RestoreCampaign.vue";
import DeactivateLink from "./partials/DeactivateLink.vue";

const emits = defineEmits(["close", "confirm"]);

const modalContents = {
  activate: {
    component: ActivateParticipant,
    title:
      "Confirmer l’activation de l'évaluation|Confirmer l’activation des évaluations",
  },
  desactivate: {
    component: DesactivateParticipant,
    title: "Désactiver l’évaluation|Désactiver les évaluations",
  },
  delete: {
    component: DeleteParticipant,
    title: "Supprimer le talent|Supprimer les talents",
  },
  move: {
    component: MoveParticipant,
    title: "Déplacer le talent|Déplacer les talents",
  },
  archive: {
    component: ArchiveCampaign,
    title: "Archiver votre campagne|Archiver les campagnes",
  },
  restore: {
    component: RestoreCampaign,
    title: "Restaurer la campagne",
  },
  deactivateLink: {
    component: DeactivateLink,
    title: "Désactiver le lien de campagne",
  },
};

const props = defineProps({
  isOpen: {
    type: Boolean,
    required: true,
  },
  data: {
    type: [Array, Object],
    required: true,
  },
  modal: {
    type: String,
    required: true,
  },
});

const modalTitle = computed(() => {
  if (!props.modal) return "";

  const title = modalContents[props.modal].title.split("|");

  return title[props.data.length > 1 ? 1 : 0];
});
</script>
